module.exports = __webpack_public_path__ + "img/logo-salz.233ef094.png";